import { InternalMessageResponse } from "features/CenterContent/RoleContent/InternalMessage/schema/responseSchema";
import { WithInternalMessages } from "features/CenterContent/RoleContent/InternalMessage/utils/withInternalMessages";
import { InternalInfoMessage } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/InternalInfoMessage";
import { TrainInfoMessage } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoMessage";
import { TrainInformationAggregated } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/types/trainInformationAggregated";
import {
  getOpenStates,
  sortTrainInfos,
} from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/utils";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";
import SkeletonLoader from "shared/components/feedback/SkeletonLoader/SkeletonLoader";

type Status = "error" | "success" | "pending";

type QueryDataStatus<T> = {
  data: T | undefined;
  status: Status;
};

export const combineStatus = (...statuses: Status[]): Status => {
  const statusPriority: Status[] = ["error", "pending", "success"];
  const highestPriority = Math.min(
    ...statuses.map((it) => statusPriority.indexOf(it)),
  );
  return statusPriority[highestPriority];
};

export const useInfoMessages = (
  trainDataStatus: QueryDataStatus<
    WithInternalMessages<TrainInformationAggregated>[]
  >,
  internalMessagesDataStatus: QueryDataStatus<InternalMessageResponse[]>,
) => {
  const status = combineStatus(
    trainDataStatus.status,
    internalMessagesDataStatus.status,
  );
  switch (status) {
    case "pending":
      return <SkeletonLoader skeletonType="listBig" />;
    case "success": {
      if (!trainDataStatus.data || !internalMessagesDataStatus.data) {
        throw Error("This should not be possible");
      }
      const internalInfoMessages =
        internalMessagesDataStatus.data.length > 0
          ? [
              <InternalInfoMessage
                key="internalInfoMessage"
                info={internalMessagesDataStatus.data}
              />,
            ]
          : [];
      const trainInfoMessages = sortTrainInfos(trainDataStatus.data).map(
        (trainInfo) => (
          <TrainInfoMessage
            info={trainInfo}
            key={trainInfo.latestInfoUuid}
            trainInfoWithOpenState={getOpenStates(trainDataStatus.data)}
          />
        ),
      );
      return [...internalInfoMessages, ...trainInfoMessages];
    }
    case "error":
      return (
        <FailureMessage customMessage="Kunne ikke hente aktive hendelser for dette toget." />
      );
  }
};
